// External
import validator from 'validator';

export const isValidEmail = (email: string): boolean => {
  // Super simple validation. The only way to really validate
  // an email is to send an email to it.
  return validator.isEmail(email);
};
